import React, { useEffect } from 'react';
import useDocumentPreview from './documentPreview/useDocumentPreview';
import DocumentPreviewBody from './documentPreview/DocumentPreviewBody';

/* Hämtningen och visningen ligger i documentPreview/ (utbrutet 2026-10-23,
   Mikael F14) så att KanAI kan visa samma källa i en högerpanel. Dialogen
   ser ut och fungerar som förut. */
export default function DocumentPreviewModal({ open, onClose, document }) {
  const preview = useDocumentPreview(open, document);
  const { error, safeName, openInNewTabUrlAbsolute } = preview;

  /* Escape to close (Del J4) */
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => { if (e.key === 'Escape') onClose?.(); };
    window.document.addEventListener('keydown', onKey);
    return () => window.document.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  if (!open || !document) return null;

  return (
    <div className="fixed inset-0 z-[500] flex items-center justify-center p-4" role="dialog" aria-modal="true" aria-label="Dokumentförhandsvisning">
      <div className="absolute inset-0 bg-slate-900/45 backdrop-blur-[4px]" onClick={onClose} />
      <div
        className="relative flex h-[80vh] w-full max-w-5xl flex-col overflow-hidden rounded-[14px] border border-slate-200 bg-white shadow-[0_24px_64px_rgba(15,23,42,.18),0_8px_24px_rgba(15,23,42,.10)] dark:border-slate-700 dark:bg-slate-900"
        style={{ animation: 'modalIn 0.3s cubic-bezier(.22,1,.36,1) both' }}
      >
        {/* Header – Del C3 */}
        <header className="flex shrink-0 items-start justify-between gap-3 border-b px-6 pb-4 pt-[22px]" style={{ borderColor: 'var(--kp-border-subtle, #E4E9F0)' }}>
          <div className="min-w-0">
            <div className="truncate text-[17px] font-bold text-slate-900 dark:text-slate-100" style={{ letterSpacing: '-0.01em' }} title={safeName}>{safeName}</div>
            <div className="mt-0.5 text-[13px] font-normal text-slate-400 dark:text-slate-400">
              Förhandsvisning från dokumentmodulen
            </div>
            {error && (
              <div className="mt-1 truncate text-[12px] font-medium text-red-600 dark:text-red-400" title={error}>
                {error}
              </div>
            )}
          </div>
          <div className="flex shrink-0 items-center gap-2">
            {openInNewTabUrlAbsolute && (
              <a
                href={openInNewTabUrlAbsolute}
                target="_blank"
                rel="noreferrer"
                className="inline-flex items-center gap-1.5 rounded-[10px] border-[1.5px] border-slate-200 bg-white px-[16px] py-[9px] text-[13.5px] font-semibold text-slate-600 transition-all hover:border-slate-400 dark:border-slate-600 dark:bg-slate-800 dark:text-slate-200"
                style={{ minHeight: 44 }}
              >
                <svg viewBox="0 0 16 16" width="14" height="14" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"><path d="M10 2h4v4" /><path d="M14 2L7 9" /><path d="M12 9v4.5a1 1 0 0 1-1 1H3.5a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1H8" /></svg>
                Öppna i ny flik
              </a>
            )}
            <button
              type="button"
              onClick={onClose}
              className="flex h-8 w-8 items-center justify-center rounded-md border border-slate-200 bg-transparent text-slate-400 transition-all hover:border-slate-900 hover:text-slate-900 dark:border-slate-600 dark:text-slate-500 dark:hover:border-slate-100 dark:hover:text-slate-100"
              style={{ minWidth: 44, minHeight: 44 }}
              aria-label="Stäng modal"
            >
              <svg viewBox="0 0 15 15" width="15" height="15" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round"><path d="M3.5 3.5l8 8M11.5 3.5l-8 8" /></svg>
            </button>
          </div>
        </header>

        {/* Body — min-h-0 är kritiskt: utan den växer flex-kroppen till
            innehållets fulla höjd (klipps av modalens overflow-hidden) och
            PdfViewerns interna skroll blir omöjlig. */}
        <div className="flex min-h-0 flex-1 items-stretch justify-center overflow-hidden bg-slate-50 dark:bg-slate-950">
          <DocumentPreviewBody document={document} preview={preview} />
        </div>
      </div>
    </div>
  );
}
